var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWrenchCircled = function SvgWrenchCircled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "currentColor"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9566,14.27967a4.30393,4.30393,0,0,0,1.72018.34358h.00041a4.30572,4.30572,0,0,0,4.17126-5.44586.43574.43574,0,0,0-.41516-.31791.44467.44467,0,0,0-.31726.13962c-.0156.01542-2.07112,2.05993-2.07112,2.05993l-1.88624-.20719L20.994,8.905s1.9923-2.00555,2.00619-2.01961a.43771.43771,0,0,0,.13138-.42646.45128.45128,0,0,0-.32191-.30944,4.3443,4.3443,0,0,0-1.13292-.15021,4.32272,4.32272,0,0,0-3.96653,6.04236s-5.56664,5.58547-5.62885,5.68336a4.32543,4.32543,0,0,0-5.92982,5.09156.43849.43849,0,0,0,.41509.32086h.00006a.44206.44206,0,0,0,.31727-.13815c.0156-.01542,2.07118-2.05917,2.07118-2.05917l1.89847.208.15728,1.947s-1.99471,2.00554-2.00861,2.01961a.4385.4385,0,0,0-.13255.42646.45067.45067,0,0,0,.32133.30938,4.34,4.34,0,0,0,1.13268.15027,4.32615,4.32615,0,0,0,3.95134-6.082C14.373,19.85649,19.9566,14.27967,19.9566,14.27967Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrenchCircled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrenchCircled.163e84f5.svg";
export { ForwardRef as ReactComponent };